import { Tabs } from '@mui/material';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  ({ spacing }) => ({
    root: {
      padding: 0,
    },
    indicator: {
      left: spacing(4),
    },
  }),
  { classNamePrefix: 'DrawerMenuAnchors' }
);

function DrawerMenuAnchors({ children, value = 0 }) {
  const classes = useStyles();

  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      classes={classes}
      indicatorColor="primary"
      value={value}
    >
      {children}
    </Tabs>
  );
}

export default DrawerMenuAnchors;
